import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { HomeComponent } from "./../features/home/home.component";
import { EngagementComponent } from "./../features/engagement/viewall-engagement/engagement.component";
import { AddEditEngagementComponent } from "./../features/engagement/add-edit/add-edit.component";
import { UploadSourcefileComponent } from "../features/upload-sourcefile/upload-sourcefile.component";
import { HelpComponent } from "./../features/help/help.component";
import { ViewSingleEngagementComponent } from "../features/engagement/viewsingle/view-singleengagement.component";
import { PreviewSourcefileComponent } from "../features/preview-sourcefile/preview-sourcefile.component";
import { StepwizardComponent } from "../features/stepwizard/stepwizard.component";
import { InputCaptureComponent } from "../features/inputcapture/inputcapture.component";
import { ScenarioresultComponent } from "../features/scenarioresult/scenarioresult.component";
import { AddEditadjustmentComponent } from "../features/adjustment/addadjustment/addadjustment.component";
import { SourcefilecolumnComponent } from "../features/sourcefilecolumn/sourcefilecolumn.component";
import { MappingselectionComponent } from "../features/mappingselection/mappingselection.component";
import { ViewadjustComponent } from "../features/adjustment/viewadjust/viewadjust.component";
import { DatabookComponent } from "../features/databook/databook.component";
import { FlatfileComponent } from "../features/flatfile/flatfile.component";
import { LoadEngagementComponent } from "../features/loadengagement/loadengagement.component";
import { RemediationComponent } from "../features/remediation/remediation.component";
import { SchedulesComponent } from "../features/schedules//schedules.component";
import { ManualdatabookaddtoqueueComponent } from "../features/manualdatabookaddtoqueue/manualdatabookaddtoqueue.component";
import { DeleteprojectdataComponent } from "../features/deleteprojectdata/deleteprojectdata.component";
import { ComparedatabookComponent } from "../features/comparedatabook/comparedatabook.component";
import { PerformdatacheckComponent } from "../features/performdatacheck/performdatacheck.component";

import { environment } from "../../environments/environment";
import { ValidationsComponent } from "../features/validations/validations.component";
import { SelectadjustmentComponent } from "../features/selectadjustment/selectadjustment.component";
import { DownloadUploadFlatfileComponent } from "../features/download-upload-flatfile/download-upload-flatfile.component";
import { UploadDatabookComponent } from "../features/upload-databook/upload-databook.component";
import { SessionExpiredComponent } from "../features/sessionExpired/sessionExpired.component";
import { AnalyticsReportComponent } from "../features/analytics-report/analytics-report.component";
import { UnauthorizeComponent } from "../features/unauthorize/unauthorize.component";
import { CountryResolver } from "../interfaces/countryResolver";

import { AllwebjobstatusComponent } from "../features/allwebjobstatus/allwebjobstatus.component";

import { PlugandplayComponent } from "../features/plugandplay/plugandplay.component";
import { CustomizedLayoutsComponent } from "../features/customized-layouts/customized-layouts.component";

const appRoutes: Routes = [
  /*{ path: '', redirectTo: '/home', pathMatch: 'full'},*/
  { path: "home", component: HomeComponent },
  { path: "engagement", component: EngagementComponent },
  { path: "engagement/:id/schedules", component: SchedulesComponent },
  {
    path: "engagement/manualdatabookaddtoqueue",
    component: ManualdatabookaddtoqueueComponent,
  },
  {
    path: "engagement/deleteprojectdata",
    component: DeleteprojectdataComponent,
  },
  { path: "comparedatabook", component: ComparedatabookComponent },
  { path: "allwebjobstatus", component: AllwebjobstatusComponent },
  { path: "addengagement", component: AddEditEngagementComponent },
  { path: "editengagement/:id", component: AddEditEngagementComponent },
  { path: "help", component: HelpComponent },
  { path: "customizedlayouts", component: CustomizedLayoutsComponent },
  { path: "viewengagement/:id", component: ViewSingleEngagementComponent },
  { path: "engagement/:id/uploadsource", component: UploadSourcefileComponent },
  {
    path: "engagement/:id/previewsourcefile",
    component: PreviewSourcefileComponent,
  },
  {
    path: "engagement/:id/previewsourcefile/:order",
    component: PreviewSourcefileComponent,
  },
  { path: "engagement/:id/flatfile", component: FlatfileComponent },
  { path: "engagement/:id/loadengagement", component: LoadEngagementComponent },
  { path: "stepwizard", component: StepwizardComponent },
  { path: "stepwizard/:id", component: StepwizardComponent },
  { path: "engagement/:id/inputcapture", component: InputCaptureComponent },
  { path: "engagement/:id/scenario", component: ScenarioresultComponent },

  {
    path: "engagement/:engagementid/adjustment/add",
    component: AddEditadjustmentComponent,
  },
  {
    path: "engagement/:id/:engagementid/adjustment/edit",
    component: AddEditadjustmentComponent,
  },
  {
    path: "engagement/:id/selectadjustment",
    component: SelectadjustmentComponent,
  },
  { path: "sourcefilecolumn", component: SourcefilecolumnComponent },
  {
    path: "engagement/:id/uploaddownloadflatfile",
    component: DownloadUploadFlatfileComponent,
  },
  {
    path: "engagement/:id/mappingselection",
    component: MappingselectionComponent,
  },
  { path: "adjustment/view/:id/:engagementid", component: ViewadjustComponent },
  { path: "engagement/:id/databook", component: DatabookComponent },
  { path: "engagement/:id/uploaddatabook", component: UploadDatabookComponent },
  { path: "engagement/:id/remediation", component: RemediationComponent },
  {
    path: "engagement/:id/performdatacheck",
    component: PerformdatacheckComponent,
  },
  { path: "sessionexpired", component: SessionExpiredComponent },
  { path: "analyticsreport", component: AnalyticsReportComponent },
  {
    path: "engagement/:id/databook/:countryId",
    component: DatabookComponent,
    resolve: {
      country: CountryResolver,
    },
  },
  {
    path: "viewengagement/:id/:countryId",
    component: ViewSingleEngagementComponent,
    resolve: {
      country: CountryResolver,
    },
  },
  {
    path: "engagement/:id/scenario/:countryId",
    component: ScenarioresultComponent,
    resolve: {
      country: CountryResolver,
    },
  },
  { path: "unauthorize", component: UnauthorizeComponent },
  /*{ path: '**', redirectTo: '/home'}*/
  { path: "layout", component: PlugandplayComponent },
  { path: "engagement/:id/layout", component: PlugandplayComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(
      appRoutes
      // { enableTracing: true }
    ),
  ],
  providers: [],
  exports: [RouterModule],
})
export class AppRoutingModule {}
